export default {
  TITLE: 'title-1',
  SUBTITLE: 'title-2',
  MCQ: 'MCQ',
  COURSE: 'course',
};
